<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Booking Property Additional Charges</h1>
      <v-btn @click="create" color="green" dark class="text-none">Create</v-btn>
    </v-layout>
    <v-layout pt-3 justify-center>
      <v-flex xs12 md8>
        <SimpleCard>
          <PropertyAdditionalCharges :propertyAdditionalCharges="propertyAdditionalCharges"/>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import PropertyAdditionalCharges from "@/components/settings/pricing/PropertyAdditionalCharges.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "property_additional_charges",
  components: {
    Overview,
    SimpleCard,
    PropertyAdditionalCharges
  },
  data: function() {
    return {
      propertyAdditionalCharges: []
    };
  },
  methods: {
    create: function() {
      this.$router.push("/settings/pricing/property_additional_charges/create");
    }
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/property_additional_charge/all`;

      let response = await axios.get(url, {
        params: {}
      });

      this.propertyAdditionalCharges = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get history");
    }
  }
};
</script>
